import React from 'react';

interface BottomNavigationProps {
  active: string;
  onNavigate: (id: string) => void;
  betCount?: number;
  openBetsCount?: number;
}

const BottomNavigation: React.FC<BottomNavigationProps> = ({ active, onNavigate, betCount = 0, openBetsCount = 0 }) => {

  const navItems = [
    { id: 'home', label: 'Home', icon: 't', svgHref: null },
    { id: 'live', label: 'Live', icon: (
      <img alt="Live" src="/images/live_time.png" style={{ width: '24px', height: '24px', objectFit: 'contain' }} />
    ), svgHref: null },
    { id: 'sport', label: 'Sport', icon: null, svgHref: '/images/svg/bets.svg#active' },
    { id: 'bets', label: 'Meine Wetten', icon: null, svgHref: '/images/svg/my-bets.svg#active' },
    { id: 'games', label: 'Games', icon: null, svgHref: '/images/svg/games.svg#active' },
    { id: 'slip', label: 'Wettschein', icon: null, svgHref: '/images/svg/betslip.svg#active' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-[120]">
      <div className="flex justify-around items-center h-16 max-w-full">
        {navItems.map((item) => (
          <button
            key={item.id}
            onClick={() => onNavigate(item.id)}
            className={`flex flex-col items-center gap-1 flex-1 h-full justify-center transition relative ${
              active === item.id
                ? 'text-tipico-red border-t-2 border-tipico-red'
                : 'text-gray-700 hover:text-gray-900'
            }`}
          >
            {item.id === 'home' ? (
              <span className="text-[25px] font-black italic tracking-tighter leading-none select-none font-sans lowercase -mt-[2px] pointer-events-none">
                t
              </span>
            ) : item.svgHref ? (
              <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" role="img" className="w-6 h-6 pointer-events-none">
                <use href={item.svgHref} />
              </svg>
            ) : (
              <span className="text-2xl pointer-events-none">{item.icon}</span>
            )}
            <span className="text-[10px] leading-tight font-semibold truncate w-full text-center px-0.5 pointer-events-none">{item.label}</span>
            {item.id === 'slip' && betCount > 0 && (
              <span className="absolute top-1 right-3 bg-tipico-red text-white text-xs rounded-full w-4 h-4 flex items-center justify-center font-bold pointer-events-none">
                {betCount}
              </span>
            )}
            {item.id === 'bets' && openBetsCount !== undefined && openBetsCount > 0 && (
              <span className="absolute top-1 right-3 bg-tipico-red text-white text-xs rounded-full min-w-4 px-1 h-4 flex items-center justify-center font-bold pointer-events-none">
                {openBetsCount}
              </span>
            )}
          </button>
        ))}
      </div>
    </nav>
  );
};

export default BottomNavigation;
